<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerText]="data.title"
	[headerIcon]="{fontIcon: 'fa-book', fontSet: 'fa'}"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
>
	<ng-container dialogContent>
		@if (data?.jobLogs?.length <= 0) {
			<div>{{ T.JOB_LOG_DIALOG_NO_LOGS_FOUND | translate }}</div>
		} @else {
			<div class="tableStyle mat-elevation-z8">
				<table [dataSource]="data.jobLogs" mat-table style="width: 100%">
					<ng-container matColumnDef="createdOn">
						<th *matHeaderCellDef mat-header-cell>
							{{ T.RUNNING_SCENARIO_RECORDING_CREATED_DATE | translate }}
						</th>
						<td
							*appMatCellDef="let element; dataSource: data?.jobLogs"
							[innerHTML]="element.createdOn | date: (T.DATE_FORMAT_ADMIN | translate) :'': translate.currentLang"
							mat-cell
						></td>
					</ng-container>
					<ng-container matColumnDef="type">
						<th *matHeaderCellDef mat-header-cell>
							{{ T.NOTIFICATIONS_TABLE_TYPE | translate }}
						</th>
						<td *appMatCellDef="let element; dataSource: data?.jobLogs" mat-cell>
							{{ element.type }}
						</td>
					</ng-container>
					<ng-container matColumnDef="name">
						<th *matHeaderCellDef mat-header-cell>
							{{ T.USER_TABLE_FIRSTNAME | translate }}
						</th>
						<td *appMatCellDef="let element; dataSource: data?.jobLogs" mat-cell>
							{{ element.name }}
						</td>
					</ng-container>
					<ng-container matColumnDef="text">
						<th *matHeaderCellDef mat-header-cell>
							{{ T.CONFIGURATION_EDITOR_SETTINGS_TYPE_STRING | translate }}
						</th>
						<td
							*appMatCellDef="let element; dataSource: data?.jobLogs"
							[innerHTML]="element.text"
							class="newline"
							mat-cell
							style="margin-left: 30px"
						></td>
					</ng-container>
					<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
					<tr
						*matRowDef="let row; columns: displayedColumns"
						[ngClass]="{
							danger: row.type === SchedulerEventLogType.Failure,
							success: row.type === SchedulerEventLogType.Success,
						}"
						mat-row
					></tr>
				</table>
			</div>
		}
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="close({action: 'ok'})"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="data.okText"
		/>
	</ng-container>
</sim-basic-material-dialog>
